
const Sustainabel = [

    
    {

        
        info: "People",
        Textinfo: "We consider our people our greatest asset. We aspire to be the best-in-class in people practices, encourage their development and support their ideas in value generation.",
        symbol: "/networking.png"
        
    },

    
    {

        
        info: "Quality",
        Textinfo: "We are constantly motivated on improving our quality through a culture of benchmarking best practices and leveraging analytics.",
          symbol: "/quality.png"
    },

    {

        
        info: "Growth",
        Textinfo: "We are committed to the triple bottom line of people, planet and prosperity as we grow  exponentially in all businesses thereby making contributions to the nation at large.",
            symbol: "/growth.png"
    },
   
    {

        
        info: "Value, Ethics & Governance",
        Textinfo: "We actively foster a culture of mutual trust in our interactions with our stakeholders and encourage an open dialogue which ensures mutual respect. We aim for zero tolerance on the fundamentals.",
        symbol: "/connection.png"
    },

    {

        
        info: "Giving back to the community/society",
        Textinfo: "We are committed to contributing and empowering communities thereby making an impact on human lives.",
        symbol: "/society.png"
    },

    {

        
        info: "Sustainability, Safety, Health & Environment",
        Textinfo: " We are committed to zero harm, zero waste and zero discharge. We ensure that our security, intelligence and vigilance are well integrated by leveraging technology.",
        symbol: "/sustainability2.png"
    },

    {

        
        info: "Digital, Innovation, Technology & Excellence",
        Textinfo: " We embrace adopting state-of-the-art technology driver in all our processes. We believe the next phase of growth can only be achieved through new technologies and innovation",
        symbol: "/technology.png"
    },





]

export default Sustainabel;